// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodProjectId } from './FoodProject';
import { foodSessionStatusEnum } from './FoodSessionStatusEnum';
import { calendarDate } from '../../calendar-date';
import { operatorId } from './Operator';
import { brewBatchId } from './BrewBatch';
import { z } from 'zod';
export const foodSessionId = (z.number());
export const foodSession = z.object({
    id: foodSessionId,
    project_id: foodProjectId,
    code: z.string(),
    status: foodSessionStatusEnum,
    goal: z.string().nullable(),
    planned_date: calendarDate.nullable(),
    assigned_operator_id: operatorId.nullable(),
    brew_batch_id: brewBatchId.nullable(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const foodSessionInitializer = z.object({
    id: foodSessionId.optional(),
    project_id: foodProjectId,
    code: z.string(),
    status: foodSessionStatusEnum.optional(),
    goal: z.string().optional().nullable(),
    planned_date: calendarDate.optional().nullable(),
    assigned_operator_id: operatorId.optional().nullable(),
    brew_batch_id: brewBatchId.optional().nullable(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const foodSessionMutator = z.object({
    id: foodSessionId.optional(),
    project_id: foodProjectId.optional(),
    code: z.string().optional(),
    status: foodSessionStatusEnum.optional(),
    goal: z.string().optional().nullable(),
    planned_date: calendarDate.optional().nullable(),
    assigned_operator_id: operatorId.optional().nullable(),
    brew_batch_id: brewBatchId.optional().nullable(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FoodSession.js.map